import Vue from "vue";

// stempcore 只消费 $t，不强制宿主接入 vue-i18n：
// 宿主未注入 $t（未开国际化）时提供中文兜底，已注入时零影响。
// 已装 vue-i18n 的宿主（如 member-template-vue）在 Vue.use(VueI18n) 时
// 会无条件重挂 Vue.prototype.$t（8.28.2 实测），自动覆盖此兜底。
var MESSAGES = {
  "field.please_input": "请输入{name}",
  "field.please_input_captcha": "请输入验证码",
};

function fallbackT(key, options) {
  // 宿主开了国际化但只挂了 window.$sk.$t 时，转发宿主翻译
  if (window.$sk && typeof window.$sk.$t === "function") {
    return window.$sk.$t(key, options);
  }
  var s = MESSAGES[key] || key;
  if (options) {
    for (var k in options) {
      s = s.split("{" + k + "}").join(options[k]);
    }
  }
  return s;
}

if (!Vue.prototype.$t) {
  Vue.prototype.$t = fallbackT;
}
